"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeableProxyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var UpgradeableProxyFactory = /** @class */ (function (_super) {
    __extends(UpgradeableProxyFactory, _super);
    function UpgradeableProxyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    UpgradeableProxyFactory.prototype.deploy = function (_logic, _data, overrides) {
        return _super.prototype.deploy.call(this, _logic, _data, overrides || {});
    };
    UpgradeableProxyFactory.prototype.getDeployTransaction = function (_logic, _data, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _logic, _data, overrides || {});
    };
    UpgradeableProxyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    UpgradeableProxyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    UpgradeableProxyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return UpgradeableProxyFactory;
}(contracts_1.ContractFactory));
exports.UpgradeableProxyFactory = UpgradeableProxyFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_logic',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: '_data',
                type: 'bytes',
            },
        ],
        stateMutability: 'payable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'implementation',
                type: 'address',
            },
        ],
        name: 'Upgraded',
        type: 'event',
    },
    {
        stateMutability: 'payable',
        type: 'fallback',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '0x608060405260405161037d38038061037d8339818101604052604081101561002657600080fd5b81516020830180516040519294929383019291908464010000000082111561004d57600080fd5b90830190602082018581111561006257600080fd5b825164010000000081118282018810171561007c57600080fd5b82525081516020918201929091019080838360005b838110156100a9578181015183820152602001610091565b50505050905090810190601f1680156100d65780820380516001836020036101000a031916815260200191505b50604052506100e3915050565b6100ec826101ab565b8051156101a4576000826001600160a01b0316826040518082805190602001908083835b6020831061012f5780518252601f199092019160209182019101610110565b6001836020036101000a038019825116818451168082178552505050505050905001915050600060405180830381855af49150503d806000811461018f576040519150601f19603f3d011682016040523d82523d6000602084013e610194565b606091505b50509050806101a257600080fd5b505b5050610259565b6101be8161021d60201b6100271760201c565b6101f95760405162461bcd60e51b81526004018080602001828103825260368152602001806103476036913960400191505060405180910390fd5b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc55565b6000813f7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a47081811480159061025157508115155b949350505050565b60e0806102676000396000f3fe608060405236601057600e6013565b005b600e5b60196025565b602560216062565b6087565b565b6000813f7fc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470818114801590605a57508115155b949350505050565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5490565b3660008037600080366000845af43d6000803e80801560a5573d6000f35b3d6000fdfea2646970667358221220f6e79b1679e60b6176672f2280a3581fce3bd1f678760357d140a53702c9f09464736f6c634300070400335570677261646561626c6550726f78793a206e657720696d706c656d656e746174696f6e206973206e6f74206120636f6e7472616374';
//# sourceMappingURL=UpgradeableProxyFactory.js.map